import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const TimeIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 32 32',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <path d="M 16 4 C 9.382813 4 4 9.382813 4 16 C 4 22.617188 9.382813 28 16 28 C 22.617188 28 28 22.617188 28 16 L 26 16 C 26 21.535156 21.535156 26 16 26 C 10.464844 26 6 21.535156 6 16 C 6 10.464844 10.464844 6 16 6 C 19.703125 6 22.898438 8.019531 24.625 11 L 21 11 L 21 13 L 28 13 L 28 6 L 26 6 L 26 9.34375 C 23.847656 6.113281 20.167969 4 16 4 Z M 15 8 L 15 17 L 22 17 L 22 15 L 17 15 L 17 8 Z"></path>
  </SvgIcon>
);

export default TimeIcon;
